import { PermissionLevel } from '../types';

/**
 * Determines the home route based on user permissions
 * Users with /home EDIT permission go to /home
 * Users without /home EDIT permission go to /modules
 */
export const getHomeRoute = (
  accountId: string,
  hasPermission: (resource: string, level: PermissionLevel) => boolean
): string => {
  const hasHomeAccess = hasPermission('/home', PermissionLevel.EDIT);
  if (hasHomeAccess) {
    return `/accounts/${accountId}/home`;
  }
  return `/accounts/${accountId}/modules`;
};
